module.exports = __webpack_public_path__ + "img/price-list.d4c782a8.png";